import { createRouter, createWebHashHistory } from 'vue-router';
import { constantsRoute } from './constants';
import { createGuard } from './guard';
import { asyncRoutes } from './routes';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    ...constantsRoute,
    ...asyncRoutes,
    {
      path: '/:pathMatch(.*)',
      name: 'Catch',
      meta: {
        title: '404',
      },
      redirect: '/not-found',
    },
  ],
});

createGuard(router);

export default router;
